module.exports = __webpack_public_path__ + "img/qd-img-8.2fac052b.jpg";